import getDateObject from '@stencil/flights-date-utils/src/get-date-object';
import {
  IFaqData,
  IUpdate_Srp_Seo_FAQ,
  IUpdate_Srp_Seo_Data,
  ISrpSeoData,
  ISrpSeoThorData,
  IUpdate_Srp_Seo_Thor_Data,
  IUpdate_Fare_Calendar_Data,
  IFareCalendarData
} from './types';

export const UPDATE_FLAVOUR = 'UPDATE_FLAVOUR';
export const UPDATE_SRP_SEO_FAQ = 'UPDATE_SRP_SEO_FAQ';
export const UPDATE_SRP_SEO_DATA = 'UPDATE_SRP_SEO_DATA';
export const UPDATE_SRP_SEO_THOR_DATA = 'UPDATE_SRP_SEO_THOR_DATA';
export const UPDATE_JOURNEY_TYPE = 'UPDATE_JOURNEY_TYPE';
export const UPDATE_TRAVEL_TYPE = 'UPDATE_TRAVEL_TYPE';
export const UPDATE_SOURCE_DESTINATION = 'UPDATE_SOURCE_DESTINATION';
export const UPDATE_MODIFY_SEARCH_WIDGET = 'UPDATE_MODIFY_SEARCH_WIDGET';
export const UPDATE_SEARCH_WIDGET_LOCATION = 'UPDATE_SEARCH_WIDGET_LOCATION';
export const UPDATE_SEARCH_WIDGET_DEP_ARR = 'UPDATE_SEARCH_WIDGET_DEP_ARR';
export const UPDATE_SEARCH_WIDGET_PAX = 'UPDATE_SEARCH_WIDGET_PAX';
export const UPDATE_SEARCH_WIDGET_FLIGHT_CLASS = 'UPDATE_SEARCH_WIDGET_FLIGHT_CLASS';
export const UPDATE_SEARCH_WIDGET_SWAP_SOURCE_DESTINATION =
  'UPDATE_SEARCH_WIDGET_SWAP_SOURCE_DESTINATION';
export const UPDATE_SELECTED_FLIGHT = 'UPDATE_SELECTED_FLIGHT';
export const UPDATE_MINFARE_DATA = 'UPDATE_MINFARE_DATA';
export const UPDATE_QUERY_PARAMS_FROM_URL = 'UPDATE_QUERY_PARAMS_FROM_URL';
export const UPDATE_OFFER_DATA = 'UPDATE_OFFER_DATA';
export const UPDATE_FARE_CALENDAR_DATA = 'UPDATE_FARE_CALENDAR_DATA';
export const UPDATE_FARE_TRENDS_DATA = 'UPDATE_FARE_TRENDS_DATA';
export const UPDATE_SEO_LANGUAGE = 'UPDATE_SEO_LANGUAGE';
export const SET_COMMON_FARE_RULES = 'SET_COMMON_FARE_RULES';
export const APPLY_STUDENT_FARE_FILTER = 'APPLY_STUDENT_FARE_FILTER';
export const APPLY_DEFENCE_FARE_FILTER = 'APPLY_DEFENCE_FARE_FILTER';
export const APPLY_SENIOR_CITIZEN_FARE_FILTER = 'APPLY_SENIOR_CITIZEN_FARE_FILTER';
export const SET_BANNER_DETAILS = 'SET_BANNER_DETAILS';
export const SET_SPECIAL_FARE_OPTIONS = 'SET_SPECIAL_FARE_OPTIONS';
export const SET_SELECTED_FARE_IDENTIFIER = 'SET_SELECTED_FARE_IDENTIFIER';
export const SET_EXPERIMENT_DETAILS = 'SET_EXPERIMENT_DETAILS';
export const SET_EXPERIMENT_META_DATA = 'SET_EXPERIMENT_META_DATA';
export const UPDATE_SEARCH_WIDGET_ANY_TIME = 'UPDATE_SEARCH_WIDGET_ANY_TIME';
export const UPDATE_SEARCH_WIDGET_TRAVEL_DATE = 'UPDATE_SEARCH_WIDGET_TRAVEL_DATE';
export const UPDATE_SEARCH_WIDGET_TRIP_DURATION = 'UPDATE_SEARCH_WIDGET_TRIP_DURATION';
export const UPDATE_SELECTED_DESTINATION = 'UPDATE_SELECTED_DESTINATION';
export const SORT_DESTINATIONS = ' SORT_DESTINATIONS';
export const SORT_FLIGHTS = ' SORT_FLIGHTS';
export const UPDATE_THOR_HIT_ERR_MSG = ' UPDATE_THOR_HIT_ERR_MSG';
export const APPLY_FITLERS = 'APPLY_FITLERS';
export const UPDATE_ANYWHERE = 'UPDATE_ANYWHERE';
export const ADD_STATIC_INFORMATION = 'ADD_STATIC_INFORMATION';
export const ADD_CORRELATION_ID_FOR_LOGGING = 'ADD_CORRELATION_ID_FOR_LOGGING';
export const UPDATE_THOR_DATA = 'UPDATE_THOR_DATA';
export const INSERT_MSE_FLIGHTS = 'INSERT_MSE_FLIGHTS';
export const UPDATE_DEPARTURE = 'UPDATE_DEPARTURE';
export const UPDATE_ARRIVAL = 'UPDATE_ARRIVAL';
export const SET_UUID = 'SET_UUID';
export const UPDATE_SRP_SEO_THOR_DATA_GROUND_UP = 'UPDATE_SRP_SEO_THOR_DATA_GROUND_UP';
export const SET_PRE_SEARCH_BANNER_DETAILS = 'SET_PRE_SEARCH_BANNER_DETAILS';
export const SET_IS_FARE_OPTIONS_RECEIVED = 'SET_IS_FARE_OPTIONS_RECEIVED';
export const SET_SELECTED_BANNER_DETAILS = 'SET_SELECTED_BANNER_DETAILS';
export const SET_SEO_OMNITURE_INFO = 'SET_SEO_OMNITURE_INFO';

export function updateFlavour(flavour) {
  return {
    type: UPDATE_FLAVOUR,
    props: { flavour }
  };
}

export const updateSrpSeoFAQ = (actionData: Array<IFaqData>): IUpdate_Srp_Seo_FAQ => {
  return {
    type: UPDATE_SRP_SEO_FAQ,
    actionData
  };
};

export const updateSrpSeoData = (actionData: ISrpSeoData): IUpdate_Srp_Seo_Data => {
  return {
    type: UPDATE_SRP_SEO_DATA,
    actionData
  };
};

export const updateFareCalendarData = (
  actionData: IFareCalendarData
): IUpdate_Fare_Calendar_Data => {
  return {
    type: UPDATE_FARE_CALENDAR_DATA,
    actionData
  };
};

export const updateFareTrendsData = (actionData: IFareCalendarData): IUpdate_Fare_Calendar_Data => {
  return {
    type: UPDATE_FARE_TRENDS_DATA,
    actionData
  };
};

export const updateSrpSeoThorData = (actionData: ISrpSeoThorData): IUpdate_Srp_Seo_Thor_Data => {
  return {
    type: UPDATE_SRP_SEO_THOR_DATA,
    actionData
  };
};

export const updateSrpSeoThorDataGroundUp = actionData => {
  return {
    type: UPDATE_SRP_SEO_THOR_DATA_GROUND_UP,
    actionData
  };
};

export const updateQueryParamsFromUrl = actionData => {
  return {
    type: UPDATE_QUERY_PARAMS_FROM_URL,
    actionData
  };
};

export function updateJourneyType(journeyType, arrival?) {
  return {
    type: UPDATE_JOURNEY_TYPE,
    actionData: {
      journeyType,
      arrival: arrival ? getDateObject(arrival) : null
    }
  };
}

export function sortDestinations(actionData) {
  return {
    type: SORT_DESTINATIONS,
    actionData
  };
}

export const updateTravelType = actionData => {
  return {
    type: UPDATE_TRAVEL_TYPE,
    actionData
  };
};

export const updateSearchWidgetLocation = actionData => {
  return {
    type: UPDATE_SEARCH_WIDGET_LOCATION,
    actionData
  };
};

export const updateSearchWidgetDepartureArrival = actionData => {
  return {
    type: UPDATE_SEARCH_WIDGET_DEP_ARR,
    actionData
  };
};

export const updateSearchWidgetPassengers = actionData => {
  return {
    type: UPDATE_SEARCH_WIDGET_PAX,
    actionData
  };
};

export const updateSearchWidgetFlightClass = actionData => {
  return {
    type: UPDATE_SEARCH_WIDGET_FLIGHT_CLASS,
    actionData
  };
};

export const updateSearchWidgetAnyTime = anyTime => {
  return {
    type: UPDATE_SEARCH_WIDGET_ANY_TIME,
    actionData: {
      anyTime: anyTime
    }
  };
};

export const updateSearchWidgetTravelDate = travelDate => {
  return {
    type: UPDATE_SEARCH_WIDGET_TRAVEL_DATE,
    actionData: {
      travelDate: getDateObject(travelDate ? travelDate : new Date())
    }
  };
};

export const updateSearchWidgetTripDuration = tripDuration => {
  return {
    type: UPDATE_SEARCH_WIDGET_TRIP_DURATION,
    actionData: {
      tripDuration: tripDuration
    }
  };
};

export const updateSearchWidgetSwapSourceDestination = actionData => {
  return {
    type: UPDATE_SEARCH_WIDGET_SWAP_SOURCE_DESTINATION,
    actionData
  };
};

export const updateModifySearchWidget = actionData => {
  return {
    type: UPDATE_MODIFY_SEARCH_WIDGET,
    actionData
  };
};

export const updateSelectedFlight = actionData => {
  return {
    type: UPDATE_SELECTED_FLIGHT,
    actionData
  };
};

export const updateMinfareData = actionData => {
  return {
    type: UPDATE_MINFARE_DATA,
    actionData
  };
};

export const updateOfferData = actionData => {
  return {
    type: UPDATE_OFFER_DATA,
    actionData
  };
};

export const updateSeoLanguage = actionData => {
  return {
    type: UPDATE_SEO_LANGUAGE,
    actionData
  };
};

export function setCommonFareRulesData(actionData) {
  return {
    type: SET_COMMON_FARE_RULES,
    actionData
  };
}

export function applyStudentFareFilter(actionData) {
  return {
    type: APPLY_STUDENT_FARE_FILTER,
    actionData: {
      isStudentFare: actionData
    }
  };
}

export function applyDefenceFareFilter(actionData) {
  return {
    type: APPLY_DEFENCE_FARE_FILTER,
    actionData: {
      isDefenceFare: actionData
    }
  };
}

export function applySeniorCitizenFareFilter(actionData) {
  return {
    type: APPLY_SENIOR_CITIZEN_FARE_FILTER,
    actionData: {
      isSeniorCitizenFare: actionData
    }
  };
}

export function setBannerDetails(actionData) {
  return {
    type: SET_BANNER_DETAILS,
    actionData
  };
}

export function setSpecialFareOptions(actionData) {
  return {
    type: SET_SPECIAL_FARE_OPTIONS,
    actionData
  };
}

export const setSelectedFareIdentifier = actionData => {
  return {
    type: SET_SELECTED_FARE_IDENTIFIER,
    actionData
  };
};

export const setExperimentDetails = actionData => {
  return {
    type: SET_EXPERIMENT_DETAILS,
    props: actionData
  };
};

export const setExperimentMetaData = actionData => {
  return {
    type: SET_EXPERIMENT_META_DATA,
    props: actionData
  };
};

export function updateSelectedDestination(destination) {
  return {
    type: UPDATE_SELECTED_DESTINATION,
    actionData: {
      selectedDestination: destination
    }
  };
}

export function sortFlights(actionData) {
  return {
    type: SORT_FLIGHTS,
    actionData
  };
}

export function applyFilter(actionData) {
  return {
    type: APPLY_FITLERS,
    actionData
  };
}

export const updateAnywhere = isAnywhere => {
  return {
    type: UPDATE_ANYWHERE,
    actionData: {
      isAnywhere: isAnywhere
    }
  };
};

// thor
export function updateSrpErrMsg(actionData) {
  return {
    type: UPDATE_THOR_HIT_ERR_MSG,
    actionData
  };
}

export function addStaticInformation(actionData) {
  return {
    type: ADD_STATIC_INFORMATION,
    actionData
  };
}

export function addCorrelationIdForLogging(actionData) {
  return {
    type: ADD_CORRELATION_ID_FOR_LOGGING,
    actionData
  };
}

export function updateThorData(actionData) {
  return {
    type: UPDATE_THOR_DATA,
    actionData
  };
}

export function insertMSEFlights(actionData) {
  return {
    type: INSERT_MSE_FLIGHTS,
    actionData
  };
}

export function updateSourceDestination(data) {
  return {
    type: UPDATE_SOURCE_DESTINATION,
    props: { ...data }
  };
}

export const updateDeparture = departure => {
  return {
    type: UPDATE_DEPARTURE,
    actionData: {
      departure: departure ? getDateObject(departure) : getDateObject(new Date())
    }
  };
};

export const updateArrival = arrival => {
  return {
    type: UPDATE_ARRIVAL,
    actionData: {
      arrival: arrival ? getDateObject(arrival) : getDateObject(new Date())
    }
  };
};

export function setDeviceId(uuid) {
  return {
    type: SET_UUID,
    props: { uuid }
  };
}

export const setGroundUpPreSearchBannerDetails = actionData => {
  return {
    type: SET_PRE_SEARCH_BANNER_DETAILS,
    actionData
  };
};

export const setSelectedBannerDetails = actionData => {
  return {
    type: SET_SELECTED_BANNER_DETAILS,
    actionData
  };
};

export function setSEOOmnitureInfo(seoOmnitureInfo) {
  return {
    type: SET_SEO_OMNITURE_INFO,
    actionData: { seoOmnitureInfo }
  };
}
